export default (set, get, { key, actionName, payload }) => set(
  () => ({
    ...get(),
    ...payload,
  }),
  false,
  { type: `${key}/${actionName}`, payload: { ...payload } }
);
